// @ts-nocheck
import { Inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SEND_SERVICE } from '../../../../services/send.service';

@Injectable({
  providedIn: 'root',
})
export class GridBoxService {
  readonly sendService = Inject(SEND_SERVICE);

  public clearTable = new Subject();

  public auxFunction<T>(fn, params): Promise<any> {
    if (fn === 'basePercentCalc')
      return new Promise((resolve) => {
        const calc = { valor: (params.baseValueCredit * params.percentCredit) / 100 };
        return resolve(calc);
      });
    return Promise.resolve();
  }

  public auxEntity<T>(uri, params): Observable<T> {
    return this.sendService.get(uri, { params });
  }

  public getDinamicUrl<T>(url, params): Observable<T> {
    return this.sendService.get(url, { params });
  }
}
